import { extractTextFromQuery } from '../../../utils/query';
import { site_name_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word){
          return {
            evaluationEventEducatorEvent: {
              $where: {
                ...site_name_$ilike_includes(word)
              }
            }
          };
        })
      }
    }
  }
}
